import { render, staticRenderFns } from "./issueoutview.vue?vue&type=template&id=95b2424e&scoped=true&"
import script from "./issueoutview.vue?vue&type=script&lang=js&"
export * from "./issueoutview.vue?vue&type=script&lang=js&"
import style0 from "./issueoutview.vue?vue&type=style&index=0&id=95b2424e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b2424e",
  null
  
)

export default component.exports